<template>
  <ModalDialog
    ref="dialog"
    title="Supplier Confirmation"
    :submitting="submitting"
    submitTitle="Confirm"
    icon="fa-clipboard-check"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Confirmation Reference Number">
        <FormInputText v-model="confirmInfo.supplierConfirmRef" field="supplierConfirmRef" />
      </FormRow>
      <FormHorizontalRule />
      <h4>Shipping</h4>
      <FormRow label="Received Shipping Advisory Date">
        <FormCheckbox v-model="confirmInfo.isShippingDateAdvised" />
      </FormRow>
      <FormRow label="Shipping Date Advised" v-show="confirmInfo.isShippingDateAdvised">
        <FormDate v-model="confirmInfo.dateAdvisedShipping" field="dateAdvisedShipping" />
      </FormRow>
      <FormRow label="Shipping Advised Note" v-show="confirmInfo.isShippingDateAdvised">
        <FormInputText v-model="confirmInfo.advisedNoteShipping" field="advisedNoteShipping" />
      </FormRow>
      
      <FormHorizontalRule />
      <h4>Receiving</h4>
      <FormRow label="Received Advisory Date">
        <FormCheckbox v-model="confirmInfo.isDateAdvised" />
      </FormRow>
      <FormRow label="Receiving Date Advised" v-show="confirmInfo.isDateAdvised">
        <FormDate v-model="confirmInfo.dateAdvised" field="dateAdvised" />
      </FormRow>
      <FormRow label="Receiving Advised Note" v-show="confirmInfo.isDateAdvised">
        <FormInputText v-model="confirmInfo.advisedNote" field="advisedNote" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'SupplierConfirmationDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    purchaseOrderId: Number,
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      confirmInfo: {
        supplierConfirmRef: '',
        isDateAdvised: false,
        isShippingDateAdvised: false
      },
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.confirmInfo = { supplierConfirmRef: '', isDateAdvised: false, isShippingDateAdvised: false }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var confirmData = {
        supplierConfirmRef: this.confirmInfo.supplierConfirmRef
      }
      if(this.confirmInfo.isDateAdvised) {
        confirmData.dateAdvised = this.confirmInfo.dateAdvised
        confirmData.advisedNote = this.confirmInfo.advisedNote
      }
      if(this.confirmInfo.isShippingDateAdvised) {
        confirmData.dateAdvisedShipping = this.confirmInfo.dateAdvisedShipping
        confirmData.advisedNoteShipping = this.confirmInfo.advisedNoteShipping
      }

      this.$apiService.purchasingService.supplierConfirmedPurchaseOrder(this.purchaseOrderId, confirmData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    }
  }
}
</script>